// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"uF6wiQgb","contentContainer":"yG8DqI3X","labelContainer":"gF3CW705","label":"jH54UNQv","title":"HRWRZx8E","description":"vOrLdfxL","moreButton":"cde_wm9t"};